<template>
  <PageSection
    class="training-section-icon-blocks"
  >
    <template #default>
      <div class="container">
        <h2
          v-if="title"
          class="title"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 300}"
          v-html="title"
        ></h2>
        <div
          v-if="subtitle"
          class="subtitle"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 350}"
          v-html="subtitle"
        ></div>
        <div
          v-if="iconBlocks && iconBlocks.length"
          class="icon-blocks-grid"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 400}"
        >
          <TrainingSectionIconBlockItem
            v-for="(block, index) in iconBlocks"
            :key="`icon-block-${index}`"
            :icon="block.Icon"
            :title="block.Title"
            :text="block.Text"
          />
        </div>
      </div>
    </template>
  </PageSection>
</template>

<script>
import PageSection from '@/components/PageSection.vue';
import TrainingSectionIconBlockItem from './TrainingSectionIconBlockItem.vue';

export default {
  name: 'TrainingSectionIconBlocks',
  components: {
    PageSection,
    TrainingSectionIconBlockItem,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    iconBlocks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.training-section-icon-blocks {
  @include wRule(
    padding-top,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  @include wRule(
    padding-bottom,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  .title {
    display: block;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;

    @include wRule(
      font-size,
      (
        xl: 65,
        lg: 50,
        md: 45,
        sm: 65,
      )
    );

    @include wRule(
      max-width,
      (
        xl: 1095,
        lg: 800,
        md: 700,
        sm: 100%,
      )
    );

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 30,
          lg: 25,
          md: 20,
          sm: 30,
        )
      );
    }
  }

  .subtitle {
    display: block;
    font-weight: 400;
    line-height: 1.6;

    @include wRule(
      font-size,
      (
        xl: 20,
        lg: 18,
        md: 16,
        sm: 30,
      )
    );

    @include wRule(
      max-width,
      (
        xl: 600,
        lg: 500,
        md: 450,
        sm: 100%,
      )
    );

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 60,
          lg: 50,
          md: 40,
          sm: 50,
        )
      );
    }
  }

  .icon-blocks-grid {
    display: grid;

    grid-template-columns: 1.3fr 1fr 1fr 1fr;

    @include screen("md") {
      grid-template-columns: 1fr 1fr;
    }

    @include screen("sm", max) {
      grid-template-columns: 1fr 1fr;
    }

    @include wRule(grid-column-gap, (
      xl: 15,
      lg: 12,
      md: 10,
      sm: 30,
    ));

    @include wRule(grid-row-gap, (
      xl: 80,
      lg: 48,
      md: 48,
      sm: 60,
    ));
  }
}
</style>
